import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invalid-feedback" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Submit")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
// import InputText from 'primevue/inputtext'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormExample',
  setup(__props) {

const schema = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').required('Email is required'),
  // password: Yup.string().required('Password is required')
})

const initialValues = {
  email: '',
  // password: ''
}

const onSubmit = (values: any) => {
  console.log('masukk submit')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues
    }, {
      default: _withCtx(({ errors }) => [
        _createVNode(_unref(Field), { name: "email" }, {
          default: _withCtx(({ handleChange, handleBlur }) => [
            _createVNode(_unref(InputText), {
              onChange: handleChange,
              onBlur: handleBlur,
              class: "input-primary input-invalid",
              placeholder: "Ini Placholder nya"
            }, null, 8, ["onChange", "onBlur"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, _toDisplayString(errors.email), 1),
        _createVNode(_unref(Button), {
          type: "submit",
          class: "btn-primary mr-1"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})